import { render, staticRenderFns } from "./ButtonBig.vue?vue&type=template&id=98c6b3b6&scoped=true&"
import script from "./ButtonBig.vue?vue&type=script&lang=js&"
export * from "./ButtonBig.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBig.vue?vue&type=style&index=0&id=98c6b3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c6b3b6",
  null
  
)

export default component.exports